import React from 'react';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO/SEO';
import { ServiceSchema, BreadcrumbSchema } from '../components/SEO/StructuredData';
import ServicePage from '../components/ServicePage/ServicePage';

// Import Software Design images - using IT images as placeholders
import designImage1 from '../assets/images/services/it/DATA CENTRE SETUP AND INSTALLATION.jpg';
import designImage2 from '../assets/images/services/it/EMS.jpg';
import designImage3 from '../assets/images/services/it/STRUCTURED CABLING AND NETWORKING.jpg';
import designImage4 from '../assets/images/services/it/ENTRANCE MANAGEMENT.jpg';

// Import video specific to this service
import softwareVideo from '../assets/videos/software/software-design.mp4';

// Import benefits image
import designBenefitsImage from '../assets/images/software/design-main.jpg';

const SoftwareDesignPage: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <>
      <SEO title="Software Design & UI/UX" description="Professional UI/UX design services in DRC. User-centered design, prototyping, and brand identity by Cool & Care." keywords="UI UX design DRC, software design, prototyping, user experience, brand design Kinshasa" />
      <ServiceSchema name="Software Design & UI/UX" description="Professional UI/UX design, prototyping, and brand identity services." url="/software-design" />
      <BreadcrumbSchema items={[{ name: 'Software', url: '/software' }, { name: 'Design', url: '/software-design' }]} />
      <ServicePage
        serviceName={t('servicePage.services.softwareDesign.name')}
      serviceDescription={t('servicePage.services.softwareDesign.description')}
      videoUrl={softwareVideo}
      productImages={[
        designImage1,
        designImage2,
        designImage3,
        designImage4
      ]}
      features={t('servicePage.services.softwareDesign.features', { returnObjects: true }) as string[]}
      benefits={t('servicePage.services.softwareDesign.benefits', { returnObjects: true }) as string[]}
      benefitsImage={designBenefitsImage}
    />
    </>
  );
};

export default SoftwareDesignPage;

